import ClickToPlayOverlay from "./click-to-play-overlay";
import './click-to-play-overlay.scss';

export default ClickToPlayOverlay;
